class HttpForbiddenError extends Error {

}

class QualityNotificationPositionStatus {
  Id;
  Name;
  Description;

  constructor(id, name, description) {
    this.Id = id;
    this.Name = name;
    this.Description = description;
  }
}

const QualityNotificationPositionStatuses = {
  New: new QualityNotificationPositionStatus(10, 'New', 'Prüfung'),
  Inquiry: new QualityNotificationPositionStatus(20, 'Inquiry', 'Ursachenermittlung'),
  Processing: new QualityNotificationPositionStatus(30, 'Processing', 'Freigegeben'),
  Costing: new QualityNotificationPositionStatus(40, 'Costing', 'Kostenermittlung'),
  Audit: new QualityNotificationPositionStatus(50, 'Audit', 'Kostenprüfung'),
  Completed: new QualityNotificationPositionStatus(60, 'Completed', 'Abgeschlossen'),
  Deleted: new QualityNotificationPositionStatus(80, 'Deleted', 'Gelöscht'),
  Declined: new QualityNotificationPositionStatus(90, 'Declined', 'Abgelehnt')
}

class Customer {
  Icrm_Guid;
  GenderId;
  Gender;
  SalutationId;
  Salutation;
  TitleId;
  Title;
  CustomerNumber;
  FirstName;
  FamilyName;
  IsOrganization;
  ComapnyName;
  DateOfBirth;
  LanguageId;
  Language;
  IsPrivacyPolicyApproved;
  CustomerBalance;
  Communications;
  Addresses;
  MasterOrders;
  /**
   * [NotMapped]
   */
  SalutationText;
}

class WorkOrder {

}

const OrderEventTypes = {
  AddedInSystem: 1,
  ReadyInSystem: 2,
  OrderInProductionStarted: 10039,
  InProduction: 17,
  Produced: 19,
  OrderLoaded: 10040,
  Delivered: 20,
  InstallationCompleted: 21,
  OverallAcceptanceCompleted: 22,
  BadgeGlued: 23,
  CustomerHasPayed: 24,
  Canceled: 10037
}

class QualityNotification {
  ResponsibleUserId;
  ResponsibleUser;
  ReportedByUserId;
  ReportedByUser;
  QualityNotificationSourceId;
  QualityNotificationSource;
  SourceDetails;
  QualityNotificationPositions;
  OrderEvents;
  QualityNotificationFlag
}

const QualityNotificationSource = {
  Customer: 1,
  Proxy: 2,
  Fitter: 3,
  Signer: 4,
  Designer: 5,
  Clerk: 6,
  Manufacturing: 7,
  Migration: 99
}

const EventStates = {
  Completed: 10,
  Rejected: 5,
  New: 1
}

const FieldOrderTypes = {
  LK: {Id: 1, Name: "LK", Description: "Lieferung zum Kunden"},
  LM: {Id: 2, Name: "LM", Description: "Lieferung & Montage"},
  M: {Id: 3, Name: "M", Description: "Montage"},
  AB: {Id: 4, Name: "AB", Description: "Logistikauftrag Abholung"},
  LL: {Id: 5, Name: "LL", Description: "Logistikauftrag Lagerlieferung"},
  A: { Id: 6, Name: "A", Description: "Aufmaß" },
}

const QualityNotificationStatus = {
  Open: 10,
  Inquiry: 20,
  Processing: 30,
  Rectified: 40,
  Completed: 50,
  Clarification: 80,
  Deleted: 90
}

const OrderStates = {
  Provisional: 10,
  Active: 20,
  Completed: 30,
  Canceled: 40,
  PlanInHouse: 50,
  PlanClarification: 55,
  InTechnicalEngineering: 60,
  InTechnicalReview: 65,
  EngineeringCompletedDate: 70,
  Produced: 80,
  Delivered: 90,
  Installed: 100,
}

class Payment {
  /**
   * @type {string}
   */
  AbasEntryId;
  /**
   * @type {string}
   */
  CustomerNumber;
  /**
   * @type {string}
   */
  BookingDate;
  /**
   * @type {number}
   */
  Amount;
}

export { Customer, WorkOrder, OrderEventTypes, EventStates, FieldOrderTypes, QualityNotificationStatus, QualityNotification, QualityNotificationSource, QualityNotificationPositionStatuses, QualityNotificationPositionStatus, OrderStates, Payment, HttpForbiddenError }